// extracted by mini-css-extract-plugin
module.exports = {"root":"AbandonedBookings_root__2pj9e","overFullWindow":"AbandonedBookings_overFullWindow__3NnLZ"};